import React, { Fragment, useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
import { AppBar, Button, colors, Container, CssBaseline, Hidden, Paper, Toolbar } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import PrintIcon from '@material-ui/icons/Print';

import AddIcon from '@material-ui/icons/Add';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ReplyIcon from "@material-ui/icons/Reply";
import CircularProgress from "@material-ui/core/CircularProgress";
import { insh } from "../../../../Context/InshSt";

export default function IntermediateAccAppbar(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        buttonClassnameSave,
        clasCAB,
        stElemnt,
        loading,
        clasBA,
        backHome,
        back,
        addToBS,
        setOpenDw,
        isNew
    } = props;

    return (
        <React.Fragment>
            <CssBaseline />

            
            <AppBar
                position="fixed"
                color="primary"
                style={{
                    backgroundImage: "linear-gradient(160deg, #808080 , #808080)", ...stElemnt.all.appBarBA,
                    direction: "ltr",
                    backgroundColor: "#808080",
                }}
              //  style={{ backgroundColor: "#808080" }}


            >
                <Toolbar className={clasBA.ToolbarBA} variant="dense">

                    <Hidden only={["xs"]}>
                        {/* {!isDialog && (
                           
                        )} */}
                        <Button
                            style={{ color: "#fff" }}
                            onClick={backHome}
                            startIcon={<CloseIcon />}
                        >
                            {t("forms:exit")}
                        </Button>
                        <Button
                            style={{ color: "#fff" }}
                            onClick={() => back()}
                            startIcon={<ReplyIcon />}
                        >
                            {t("forms:back")}
                        </Button>

                      
                    </Hidden>

                    <Hidden smUp={["sm"]}>

                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={backHome}
                        >
                            <CloseIcon />
                        </IconButton>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => back()}
                        >
                            <ReplyIcon />
                        </IconButton>
                       
                    </Hidden>
                    <div className={clasBA.growBA} />

                    <Hidden smUp={["sm"]}>
        
                        <div style={{ alignContent: "right", edge: "end" }}></div>

                        <div style={{ alignContent: "left", edge: "end",marginRight:"0.5rem" }}>

                            <IconButton
                                edge="end"
                                color="inherit"
                                aria-label="save"
                                disabled={loading.save}
                                onClick={(e) => addToBS("save")}
                            >
                                <SaveIcon />
                            </IconButton>
                            {loading.save && (
                                <CircularProgress size={24} className={clasCAB.buttonProgressCAB} />
                            )}
                        </div>


                      
                    </Hidden>



                    <Hidden only={["xs"]}>

                        <div className={clasCAB.wrapperCAB}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{ backgroundColor:colors.grey[700], ...stElemnt.all.iconBtn }}
                                className={buttonClassnameSave}
                                disabled={loading.save}
                                onClick={() => addToBS("save")}
                                startIcon={<SaveIcon />}
                            >
                                {isNew?"حفظ": "حفظ التعديلات"}{" "}
                            </Button>
                            {loading.save && (
                                <CircularProgress size={24} className={clasCAB.buttonProgressCAB} />
                            )}
                        </div>

                    </Hidden>
                </Toolbar>
            </AppBar>
        </React.Fragment >
    );

}